module.exports = __webpack_public_path__ + "static/media/29ADMSPC12.e0398cb9.jpg";